/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./incomingwebhook.vue?vue&type=template&id=60c06aec&scoped=true&"
import script from "./incomingwebhook.vue?vue&type=script&lang=js&"
export * from "./incomingwebhook.vue?vue&type=script&lang=js&"
import style0 from "./incomingwebhook.vue?vue&type=style&index=0&id=60c06aec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60c06aec",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCol,VRow,VTextField})
